import { Component, OnDestroy } from '@angular/core';
import { PipeServiceImpl } from "pipe-service/pipe-service-impl";

@Component({
    templateUrl: './transfer-calendar.component.html',
    styleUrls: ['./transfer-calendar.component.scss'],
})
export class TransferCalendarComponent implements OnDestroy {

    //Nombre de la confituración del visor en el json
    viewerConfigId: string = "deusto-transfer-calendar-viewer";

    constructor(private pipeService: PipeServiceImpl) {}

    ngOnDestroy(): void {
        // Necesitamos limpiar los maps por si han actualizado algún valor
        this.pipeService.refreshMaps();
    }

}